import firebase from "firebase/app";
import "firebase/auth";
import {
    isInBrowser
} from 'services/shared/Environment'
import { firebase as firebaseEnv } from 'services/shared/EnvironmentV2'
import { isNil } from "lodash";

export interface FirebaseSessionState {
  user: any;
  userIsLoggedIn: boolean;
  loggedInUserId: string;
  loggedInUserEmail: string,
  sessionInitialized: boolean;
  idToken: string;
  loggingOut: boolean;
  numLogins: number;
}

export const defaultSessionState: FirebaseSessionState = {
  user: null,
  userIsLoggedIn: false,
  loggedInUserId: "",
  loggedInUserEmail: '',
  sessionInitialized: false,
  idToken: "",
  loggingOut: false,
  numLogins: 0
};

export function whenUserLogsInOrLogsOut(
  callback: (user: firebase.User) => Promise<void> | void
) {
    if (!isInBrowser()) return;
      app().auth().onIdTokenChanged(async user => callback(user));
}

export function currentUser() {
    if (!isInBrowser()) return;
  return app().auth().currentUser;
}

export async function refreshIdToken() {
    if (!isInBrowser()) return;
    await currentUser().getIdToken(true)
}

export function userIsLoggedIn() {
    if (!isInBrowser()) return;
  return !isNil(currentUser());
}

export function currentUserEmail() {
    if (!isInBrowser()) return;
  if (!userIsLoggedIn()) {
    return "";
  }

  return currentUser().email;
}

export async function currentUserIdToken() {
    if (!isInBrowser()) return;

  if (!userIsLoggedIn()) {
    return "";
  }
  return currentUser().getIdToken();
}

export function initializeFirebaseWeb() {
  if (firebase.apps.length === 0) {
    return firebase.initializeApp(environmentConfig());
  } else {
    return firebase.app()
  }
}

export function initializeFirebaseWebWith(
  environmentConfig: FirebaseConfiguration
): firebase.app.App {
    if (!isInBrowser()) return;
  let app: firebase.app.App;

  if (firebase.apps.length === 0) {
    app = firebase.initializeApp(environmentConfig);
  } else {
    app = firebase.app();
  }

  return app;
}

export interface FirebaseConfiguration {
  apiKey: string;
  authDomain: string;
  projectId: string;
}

export function environmentConfig(): FirebaseConfiguration {

  return {
    apiKey: firebaseEnv.apiKey,
    authDomain: firebaseEnv.authDomain,
    projectId: firebaseEnv.projectId
  };
}

export function app() {
  if (!isInBrowser()) return;

  return initializeFirebaseWeb();
}

export async function resetPasswordForUserWithEmail(email: string) {
  if (!isInBrowser()) return;

  await app()
    .auth()
    .sendPasswordResetEmail(email);
}

export async function login(email: string, password: string) {
  if (!isInBrowser()) return;

  await app()
    .auth()
    .signInWithEmailAndPassword(email, password);
}

export async function logout() {
  if (!isInBrowser()) return;

  await app()
    .auth()
    .signOut();
}

export async function reauthenticateCurrentUser(email: string, password: string) {
  const credential = firebase.auth.EmailAuthProvider.credential(
    email,
    password
  );
}

export async function changePassword(email: string, oldPassword: string, newPassword: string) {
        if (!isInBrowser()) return;

     const credential = firebase.auth.EmailAuthProvider.credential(
       email,
       oldPassword
     );
     return app()
       .auth()
       .currentUser.reauthenticateWithCredential(credential)
       .then(() => app().auth().currentUser.updatePassword(newPassword));
}

export async function createUserWithEmailAndPassword(email: string, password:string) {
    if(!isInBrowser()) return;

    return app()
      .auth()
      .createUserWithEmailAndPassword(email, password);
}

export const setSession = user => {

  // Log in.
  if (user) {
    return user.getIdToken().then(token => {
      return fetch("/api/login", {
        method: "POST",
        headers: new Headers({ "Content-Type": "application/json" }),
        credentials: "same-origin",
        body: JSON.stringify({ token })
      });
    });
  }

  // Log out.
  return fetch("/api/logout", {
    method: "POST",
    credentials: "same-origin"
  });
};